



































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import ajax from "@/lib/ajax";
@Component({
    components: {}
})
export default class newCoupon extends AbpBase {
    @Prop({ type: Boolean, default: false })
    value: boolean;
    @Prop({ type: String, default: "" })
    userId: string;

    newCouponAmount: number = 0;

    get user() {
        return this.$store.state.session.user;
    }
    async save() {
        if (this.$props.userId) {
            const params = {
                userId: this.$props.userId
            };
            ajax.post("/api/services/app/User/UpdateAmount", params).then(res => {
                this.$emit("input", false);
                this.$Message.success({
                    content: "领取成功,下单时自动抵扣"
                });
                this.$emit("goRoutet")

                // this.$router.push({
                //     name: "login"
                // });
            });
        } else {
            const params = {
                userId: this.user.id
            };
              ajax.post("/api/services/app/User/UpdateAmount", params).then(res => {
                this.$emit("input", false);
                this.$Message.success({
                    content: "领取成功,下单时自动抵扣"
                });
                this.$store.dispatch('session/init');
                this.$emit("goRoutet")

            });
        }
    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
        }
    }
    created() {
        this.getNewCouponAmount();
    }
    getNewCouponAmount() {
        ajax.get("/api/services/app/User/GetNewCouponAmount").then(res => {
            if (res && res.data && res.data.result) {
                this.newCouponAmount = res.data.result;
            }
        });
    }
}
